import useSession from "hooks/useSession";
import useToast from "hooks/useToast";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IToken } from "../MyDocuments/MyDocuments.model";
import { getRetrieveSavedVeridasCall } from "./QRVeridas.service";
import { UiTmbBanner } from  'libs/raas-ui-react-components/src/components'
import { getOkVeridasQrLiterals } from "./QRVeridas.util";



export const QRVeridas = () => {
  const query = new URLSearchParams(useLocation().search);
  const customerID = query.get('user');

  const [t] = useTranslation("privateHome");
  const veridasOkLiterals = getOkVeridasQrLiterals(t);
  const navigate = useNavigate();
  const { openToast } = useToast();
  const [showIframe, setShowIframe] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [statusVeridas, setStatusVeridas] = useState("");
  const [accessToken, setAccessToken] = useState({} as IToken); // Obtención del token del usuario



  //Hook para obtener tokek especial para QR
  useEffect(() => {
    if (customerID !== null) {
      getRetrieveSavedVeridasCall(
        (response: IToken) => {
          setAccessToken(response);
          setShowIframe(true);
        },
        (err: any) => {
          openToast(
            "error",
            t("literals.errorTryAgainLater"),
            `${err?.status ? +err?.status : ""} ${err?.statusText}`
          );
        },
        customerID
      );
    }
  }, [customerID]);

  // Hooke para capturar eventos del iframe
  useEffect(() => {
    const handleMessage = (event: any) => {
      // Aquí se maneja el mensaje recibido desde el iFrame
      if (event.origin === "https://xpressid-web.eu.veri-das.com" || event.origin === "https://xpressid-web-work.eu.veri-das.com") {
        let status = "";
        switch (event.data.code) {
          case "QRProcessCompleted":
          case "ProcessCompleted":
            status = "ok";
            break;
          case "QRProcessOnboardingError":
          case "UnknownDocumentTypeError":
          case "error":
            status = "ko";
            break;
          case "QRProcessCancelled":
          case "ProcessCancelled":
            status = "ProcessCancelled";
          break;
          case "ProcessEvents":
            status = "process";
            break;
          default:
            break;
        }
        setStatusVeridas(status);
      }
    };

    // Añadir el listener de mensajes
    window.addEventListener("message", handleMessage);

    return () => {
      // Remover el listener al desmontar el componente
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  //Hook para guardar datos
  useEffect(() => {
    if (statusVeridas === "ok") {
      setShowIframe(false);
      setShowSuccess(true)
    } else if (statusVeridas === "ko") {
      setShowIframe(false);
      //getTokenVeridas();
      openToast("error", t("literals.error"), t("literals.errorTypeDocument"));
    } else if (statusVeridas === "ProcessCancelled") {
      setShowIframe(false);
    }
  }, [statusVeridas === "ok" || statusVeridas === "ko"]);

  return (
    <>
      <div slot="veridas">
        {showIframe &&
          accessToken.access_token !== null && ( // Renderiza el iframe solo si showIframe es verdadero
            <iframe
              id="XpressID-iframe"
              allow="camera; microphone; geolocation;"
              style={{ width: "100%", height: "500px", border: "none" }} // Añadir estilos para el iframe
             src={
                  (window?.location?.href?.includes(
                    "https://www.docomobility.com/app/"
                  )
                    ? "https://xpressid-web.eu.veri-das.com/v2/?access_token="
                    : "https://xpressid-web-work.eu.veri-das.com/v2/?access_token=") +
                  accessToken?.access_token
                }
            ></iframe>
          )}
               {showSuccess &&
          <UiTmbBanner  variantCSS="containerQrVeridas" literals={veridasOkLiterals}/> }
      </div>

    </>
  );
};
